import { AssetOrigin, VideoAssetStyle } from '@monorepo/types';
import { FunctionComponent } from 'react';
import { AiImageStylesComponent } from '../../features/ai-image-styles/ai-image-styles';
import { useTranslation } from 'react-i18next';

interface Props {
  assetOrigin: AssetOrigin;
  value: string;
  onChange: (value: VideoAssetStyle) => void;
}

const AssetStyles: FunctionComponent<Props> = ({
  assetOrigin,
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const getAssetStyle = () => {
    if (assetOrigin === AssetOrigin.AIImages) {
      return <AiImageStylesComponent value={value} onChange={onChange} />;
    }

    return <div>{t('common.notImplemented')}</div>;
  };
  return <div className="asset-styles">{getAssetStyle()}</div>;
};

export default AssetStyles;
